module.exports = __webpack_public_path__ + "assets/img/64c3-ph.svg";